import { render, staticRenderFns } from "./mark-on-file-badge.vue?vue&type=template&id=70950530&scoped=true&"
import script from "./mark-on-file-badge.vue?vue&type=script&lang=ts&"
export * from "./mark-on-file-badge.vue?vue&type=script&lang=ts&"
import style0 from "./mark-on-file-badge.vue?vue&type=style&index=0&id=70950530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70950530",
  null
  
)

export default component.exports